import React from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "./button";

export function RefreshButton({
  label = "Refresh",
  accessibleLabel = `Refresh ${label}`,
  loading = false,
  iconOnly = false,
  className,
  ...props
}) {
  return (
    <Button
      type="button"
      variant="refresh"
      size={iconOnly ? "icon" : "default"}
      loading={loading}
      loadingLabel="Refreshing…"
      aria-label={accessibleLabel}
      className={iconOnly ? `h-10 w-10 shrink-0 p-0${className ? ` ${className}` : ""}` : className}
      {...props}
    >
      <RefreshCw aria-hidden="true" />
      {iconOnly ? null : label}
    </Button>
  );
}
